import {AlertCategory, AlertTags} from "@/types/database.types"

// Utility function to convert title to snake_case
export const generateAlertName = (title: string): string => {
  return title
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s]/g, "") // Remove special characters
    .replace(/\s+/g, "_") // Replace spaces with underscores
    .replace(/_+/g, "_") // Replace multiple underscores with single
    .replace(/^_|_$/g, "") // Remove leading/trailing underscores
}

// Type-safe alert categories - ensures we include all categories from the enum
export const ALERT_CATEGORIES: readonly AlertCategory[] = [
  "non_compliant_communications",
  "advertising_marketing_violations",
  "client_investor_protection",
  "personal_trading_employee_conduct",
  "behavioral_sentiment_analysis",
] as const satisfies readonly AlertCategory[]

// Type-safe alert tags - ensures we include all tags from the enum
export const ALERT_TAGS: readonly AlertTags[] = [
  "all_messages",
  "incoming_only",
  "outgoing_only",
] as const satisfies readonly AlertTags[]

// Risk levels with display properties
export const RISK_LEVELS = [
  {value: "low", label: "Low", color: "text-green-600"},
  {value: "medium", label: "Medium", color: "text-yellow-600"},
  {value: "high", label: "High", color: "text-orange-600"},
  {value: "critical", label: "Critical", color: "text-red-600"},
] as const

// Human-readable labels for alert tags
export const ALERT_TAG_LABELS: Record<AlertTags, string> = {
  all_messages: "All Messages",
  incoming_only: "Incoming Only",
  outgoing_only: "Outgoing Only",
} as const satisfies Record<AlertTags, string>
